import { z } from 'zod';

export const StaffNotificationTypeSchema = z.enum([
  'CHAT_MESSAGE',
  'RECEPTION_CHECKLIST_PENDING',
  'RECEPTION_CHECKLIST_APPROVED',
  'RECEPTION_CHECKLIST_REJECTED',
  'SERVICE_ORDER_CREATED',
  'SERVICE_ORDER_STATUS_CHANGED',
  'SERVICE_QUOTE_SENT',
  'SERVICE_ORDER_ITEM_DECISION',
  'SERVICE_QUOTE_ITEM_DECISION',
  'SERVICE_ORDER_ITEM_ADDED',
  'SERVICE_ORDER_ITEM_EXECUTION_CHANGED',
  'CHECKOUT_CHECKLIST_PENDING',
  'CHECKOUT_CHECKLIST_APPROVED',
  'CHECKOUT_CHECKLIST_REJECTED',
  'WORK_TIMER_CLOSING_MECHANIC',
  'WORK_TIMER_CLOSING_SUMMARY',
]);

export const StaffNotificationListItemSchema = z.object({
  id: z.uuid(),
  type: StaffNotificationTypeSchema,
  title: z.string().min(1),
  body: z.string().min(1),
  deeplink: z.string().min(1),
  tenantId: z.uuid().nullable(),
  readAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});

export const StaffNotificationsResponseSchema = z.object({
  items: z.array(StaffNotificationListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});

export const StaffUnreadNotificationsResponseSchema = z.object({
  unreadCount: z.number().int().nonnegative(),
});

export type StaffNotificationType = z.infer<typeof StaffNotificationTypeSchema>;
export type StaffNotificationListItem = z.infer<typeof StaffNotificationListItemSchema>;
export type StaffNotificationsResponse = z.infer<typeof StaffNotificationsResponseSchema>;
export type StaffUnreadNotificationsResponse = z.infer<
  typeof StaffUnreadNotificationsResponseSchema
>;
